import { render, staticRenderFns } from "./ProjectFeedMixerSubmissionForm.vue?vue&type=template&id=1f578e93"
import script from "./ProjectFeedMixerSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectFeedMixerSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports